import React from "react";

const SharedReportsTable = ({ data }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Category</th>
          <th>Report Name</th>
        </tr>
      </thead>
      <tbody>
        {data.map(report => (
          <tr key={report.ID}>
            <td>{report.CATEGORY}</td>
            <td>{report.REPORT_NAME}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SharedReportsTable;
